module.exports = __webpack_public_path__ + "static/media/Mathan.d1389f39.jpeg";